export default "__VITE_ASSET__CeEZBgjj__"